export const altisonantes = {
    "BXCA": ["A"],
    "BXKA": ["A"],
    "BXEI": ["U"],
    "BXEY": ["U"],
    "CXCA": ["A"],
    "CXCO": ["A"],
    "CXGA": ["A"],
    "CXGO": ["A"],
    "CXKA": ["A"],
    "CXKO": ["A"],
    "CXGE": ["O"],
    "CXGI": ["O"],
    "CXJA": ["O"],
    "CXJE": ["O"],
    "CXJI": ["O"],
    "CXJO": ["O"],
    "CXLA": ["O"],
    "CXLO": ["U"],
    "FXLO": ["A"],
    "FXTO": ["E"],
    "GXTA": ["E"],
    "GXEI": ["U"],
    "GXEY": ["U"],
    "JXTA": ["E"],
    "JXTO": ["O"],
    "KXCA": ["A"],
    "KXCO": ["A"],
    "KXGA": ["A"],
    "KXGO": ["A"],
    "KXKA": ["A"],
    "KXKO": ["A"],
    "KXGE": ["O"],
    "KXGI": ["O"],
    "KXJA": ["O"],
    "KXJE": ["O"],
    "KXJI": ["O"],
    "KXJO": ["O"],
    "KXLA": ["O"],
    "KXLO": ["U"],
    "LXLO": ["I"],
    "LXCA": ["O"],
    "LXCO": ["O"],
    "LXKA": ["O"],
    "LXKO": ["O"],
    "MXME": ["A"],
    "MXMO": ["A"],
    "MXAR": ["E", "I"],
    "MXAS": ["E"],
    "MXON": ["E", "I"],
    "MXCO": ["O"],
    "MXKO": ["O"],
    "MXLA": ["U"],
    "MXLO": ["U"],
    "NXCA": ["A"],
    "NXCO": ["A"],
    "PXDA": ["E"],
    "PXDO": ["E"],
    "PXNE": ["E"],
    "PXPI": ["I"],
    "PXTO": ["I", "U"],
    "PXPO": ["O"],
    "PXTA": ["U"],
    "QXLO": ["U"],
    "RXTA": ["A"],
    "RXBA": ["O"],
    "RXBE": ["O"],
    "RXBO": ["O"],
    "RXIN": ["U"],
    "SXNO": ["E"],
    "TXTA": ["E"],
    "VXCA": ["A"],
    "VXGA": ["A"],
    "VXGO": ["A"],
    "VXKA": ["A"],
    "VXEI": ["U"],
    "VXEY": ["U"],
    "WXEI": ["U"],
    "WXEY": ["U"]
}